import { render, staticRenderFns } from "./customerImage.vue?vue&type=template&id=08a6f42f"
import script from "./customerImage.vue?vue&type=script&lang=js"
export * from "./customerImage.vue?vue&type=script&lang=js"
import style0 from "./customerImage.vue?vue&type=style&index=0&id=08a6f42f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports